import RectObject from "./RectObject";


class CheckPoint extends RectObject{
    constructor() {
        super(...arguments);
        this.fillStyle = "#f1be32";
    }
}

export default CheckPoint